import {GET, POST} from "../util";

const inspectionUrl = "api/market-sounding-decision-inspection";
const operationUrl = "api/market-sounding-decision-operation";

const url = {
    inspection: {
        list: `${inspectionUrl}/list`,
        countNew: `${inspectionUrl}/count-new`,
        messageListForInvestor: `${inspectionUrl}/:decisionId/message-list`
    },
    operation: {
        setInterested: `${operationUrl}/interested`,
        setNotInterested: `${operationUrl}/not-interested`,
        sendMessage: `${operationUrl}/:decisionId/send-message`,
    }
};

const marketSoundingDecisionApi = {
    inspection: {
        list: (params = {}) => {
            return POST(url.inspection.list, params);
        },
        getCountNew: () => {
            return GET(url.inspection.countNew);
        },
        getMessageList: (decisionId) => {
            return GET(url.inspection.messageListForInvestor.replace(":decisionId", decisionId))
        }
    },
    operation: {
        setInterested: (decisionIds, evaluation) => {
            return POST(url.operation.setInterested, { decisionIds, ...evaluation });
        },
        setNotInterested: (decisionIds, reason, evaluation) => {
            return POST(url.operation.setNotInterested, { decisionIds, reason, ...evaluation });
        },
        sendMessage: (decisionId, message) => {
            return POST(url.operation.sendMessage.replace(":decisionId", decisionId), message, "application/json", "String");
        },
    }
};

export {
    marketSoundingDecisionApi
};
